import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import tokens from "../_tokens"
import GithubSlugger from "github-slugger"
import textContent from "react-addons-text-content"

const StyledHeading = styled.h2`
  margin-top: ${2.5 * tokens.size.base}px;
  margin-bottom: ${1.5 * tokens.size.base}px;
  position: relative;

  & .icon-link {
    visibility: hidden;
    vertical-align: middle;
    font-size: 0.75em;
  }

  &:hover .icon-link,
  &:focus-within .icon-link {
    visibility: visible;
  }
`

const StyledAnchor = styled.a`
  text-decoration: none;
  padding: ${tokens.size.base}px;
  position: absolute;
  right: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-right: 5px;
  color: ${tokens.color.bgDark};
`

function MarkdownHeading({ children, ...props }) {
  const slugger = new GithubSlugger()
  const text = children ? textContent(children) : ""
  const id = text ? slugger.slug(text) : ""

  return (
    <StyledHeading id={id} {...props}>
      <StyledAnchor href={`#${id}`} aria-label={`${text} permalink`}>
        <span className="icon-link">&#128279;</span>
      </StyledAnchor>
      {children}
    </StyledHeading>
  )
}

MarkdownHeading.propTypes = {
  children: PropTypes.node,
}

const StyledH1 = styled(StyledHeading).attrs({ as: "h1" })`
  padding-bottom: 4px;
  font-size: ${tokens.fontSize.heading.xl};
  border-bottom: 1px solid ${tokens.color.border};
`

const StyledH2 = styled(StyledHeading).attrs({ as: "h2" })`
  padding-bottom: 4px;
  font-size: ${tokens.fontSize.heading.l};
  border-bottom: 1px solid ${tokens.color.border};
`

const StyledH3 = styled(StyledHeading).attrs({ as: "h3" })`
  font-size: ${tokens.fontSize.heading.m};
`

const StyledH4 = styled(StyledHeading).attrs({ as: "h4" })`
  font-size: ${tokens.fontSize.heading.s};
`

const StyledH5 = styled(StyledHeading).attrs({ as: "h5" })`
  font-size: ${tokens.fontSize.heading.xs};
`

const StyledH6 = styled(StyledHeading).attrs({ as: "h6" })`
  font-size: ${tokens.fontSize.heading.xs};
  color: ${tokens.color.text.muted};
`

export const H1 = props => <MarkdownHeading as={StyledH1} {...props} />
export const H2 = props => <MarkdownHeading as={StyledH2} {...props} />
export const H3 = props => <MarkdownHeading as={StyledH3} {...props} />
export const H4 = props => <MarkdownHeading as={StyledH4} {...props} />
export const H5 = props => <MarkdownHeading as={StyledH5} {...props} />
export const H6 = props => <MarkdownHeading as={StyledH6} {...props} />
